export default __webpack_public_path__ + "static/media/b87ddef5e19b111a.0d95d89b72e619d631ca057f1b1d632a.svg";